// extracted by mini-css-extract-plugin
export default {"section":"Hero_section__EPUrZ","textStyle":"Hero_textStyle__pwUrk","titleStyle":"Hero_titleStyle__DUGZY"};